import axios from 'axios';
import opportunityLabelsService from '@/services/opportunity-labels.service';

const initialState = () => ({
  opportunityLabels: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getOpportunityLabels({ commit }) {
    commit('GET_OPPORTUNITY_LABELS');
    return opportunityLabelsService.getOpportunityLabels().then(
      (opportunityLabels) => commit('GET_OPPORTUNITY_LABELS_SUCCESS', opportunityLabels),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('GET_OPPORTUNITY_LABELS_ERROR', error);
          throw error;
        }
      },
    );
  },
  editOpportunityLabel({ commit }, { opportunityLabelId, opportunityLabel }) {
    commit('EDIT_OPPORTUNITY_LABEL');
    return opportunityLabelsService.editOpportunityLabel({ opportunityLabelId, opportunityLabel }).then(
      (editedOpportunityLabel) => commit('EDIT_OPPORTUNITY_LABEL_SUCCESS', editedOpportunityLabel),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('EDIT_OPPORTUNITY_LABEL_ERROR', error);
          throw error;
        }
      },
    );
  },
  addOpportunityLabel({ commit }, opportunityLabel) {
    commit('CREATE_OPPORTUNITY_LABEL');
    return opportunityLabelsService.addOpportunityLabel(opportunityLabel).then(
      (createdOpportunityLabel) => commit('CREATE_OPPORTUNITY_LABEL_SUCCESS', createdOpportunityLabel),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('CREATE_OPPORTUNITY_LABEL_ERROR', error);
          throw error;
        }
      },
    );
  },
  deleteOpportunityLabel({ commit }, opportunityLabelId) {
    commit('DELETE_OPPORTUNITY_LABEL');
    return opportunityLabelsService.deleteOpportunityLabel(opportunityLabelId).then(
      () => commit('DELETE_OPPORTUNITY_LABEL_SUCCESS', opportunityLabelId),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('DELETE_OPPORTUNITY_LABEL_ERROR', error);
          throw error;
        }
      },
    );
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const mutations = {
  // The list stays shown until the new one replaces it.
  GET_OPPORTUNITY_LABELS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_OPPORTUNITY_LABELS_SUCCESS(state, opportunityLabels) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityLabels = opportunityLabels;
  },
  GET_OPPORTUNITY_LABELS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  EDIT_OPPORTUNITY_LABEL(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  EDIT_OPPORTUNITY_LABEL_SUCCESS(state, opportunityLabel) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityLabels = state.opportunityLabels.map((label) => {
      if (label.id === opportunityLabel.id) {
        return opportunityLabel;
      }
      return label;
    });
  },
  EDIT_OPPORTUNITY_LABEL_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  CREATE_OPPORTUNITY_LABEL(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  CREATE_OPPORTUNITY_LABEL_SUCCESS(state, opportunityLabel) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityLabels.unshift(opportunityLabel);
  },
  CREATE_OPPORTUNITY_LABEL_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  DELETE_OPPORTUNITY_LABEL(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  DELETE_OPPORTUNITY_LABEL_SUCCESS(state, opportunityLabelId) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunityLabels = state.opportunityLabels.filter((label) => label.id !== opportunityLabelId);
  },
  DELETE_OPPORTUNITY_LABEL_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  opportunityLabels: (state) => state.opportunityLabels,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunityLabels = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
